import { applyMiddleware, combineReducers, compose, createStore as _createStore, StoreEnhancer } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';

import {
  appStatusReducer,
  locationReducer,
  noopReducer,
  promoDetailsReducer,
  suggestionsReducer,
} from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IBlackFriday } from '../../types/blackFriday';
import { TCurrentRegion } from '../../types/currentRegion';
import { IPromosPage } from '../../types/promosPage';
import {
  IAnalytics,
  IApplicationState,
  TReduxActions,
  TReduxStore,
  IPage,
  IApplicationInitialState,
} from '../../types/redux';
import { IRegion } from '../../types/regions';
import { ISeoData } from '../../types/seoData';
import { TUser } from '../../types/user';

let storeReminder: TReduxStore;

interface IThunkExt {
  dispatch: ThunkDispatch<IApplicationState, IApplicationContext, TReduxActions>;
}

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(
  initialState: IApplicationInitialState,
  context: IApplicationContext,
  debugEnabled: boolean,
) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    analytics: noopReducer<IAnalytics>(),
    appStatus: appStatusReducer,
    blackFriday: noopReducer<IBlackFriday>(),
    currentRegion: noopReducer<TCurrentRegion>(),
    locationModal: locationReducer,
    page: noopReducer<IPage>(),
    promosPage: noopReducer<IPromosPage>(),
    promoDetails: promoDetailsReducer,
    regions: noopReducer<IRegion[]>([]),
    seoData: noopReducer<ISeoData>(),
    suggestions: suggestionsReducer,
    user: noopReducer<TUser>(),
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;
  const middlewares = [thunk.withExtraArgument(context)];
  const storeEnchancers = composeEnhancers(applyMiddleware(...middlewares)) as StoreEnhancer<IThunkExt>;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationInitialState, TReduxActions, IThunkExt, IApplicationState>(
      reducers,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
